import React from 'react';
import './Staff.css';
import tomImage from '../assets/staff/tom.jpg';
import mariImage from '../assets/staff/mari.jpg';
import mariaImage from '../assets/staff/maria.jpg';
import meghanImage from '../assets/staff/meghan.jpg';
import brandiImage from '../assets/staff/brandi.jpg';
import gigiImage from '../assets/staff/gigi.jpg';
import teamImage from '../assets/staff/team.jpg';

const Staff: React.FC = () => {
  const staffMembers = [
    {
      name: "Dr. Tom Ellerhorst, DDS, MSD",
      title: "Orthodontist",
      image: tomImage,
      description: `Dr. Tom Ellerhorst, also known as "Dr. Tom," grew up in San Carlos and attended St. Charles Elementary School, followed by Junipero Serra High School in San Mateo, where he was selected as Valedictorian and received the Varsity Soccer Blanket Award. He then pursued studies in Biology and Chemistry at the University of San Francisco before earning his Dental and Masters degrees at the Arthur A. Dugoni School of Dentistry, University of the Pacific in San Francisco. He is a local through and through!

Continuing the dental tradition within his family, Dr. Tom follows in the footsteps of his mother, Dr. Ann Marie Silvestri, and his father, Dr. Tom Ellerhorst, both of whom are general dentists. He is a Diplomat of the American Board of Orthodontists (Board Certified) and an active member of numerous professional associations including the American Association of Orthodontists, San Mateo County Dental Society, California Society of Orthodontists, American Dental Association, California Dental Association, and University of the Pacific Alumni Association. Additionally, he is recognized as a Platinum Invisalign Provider.

Dr. Tom married his high school sweetheart, Kacie, and currently resides in Redwood City. He dedicates much of his free time to keeping up with his children's various activities, including coaching basketball and baseball for his son Connor's school teams. He takes joy in watching his children participate in their club-level sports. Dr. Tom is an avid fan of Adam Sandler and Will Ferrell movies and cherishes spending time with his extended family throughout the Peninsula.`
    },
    {
      name: "Mari",
      title: "Patient Care Coordinator",
      image: mariImage,
      description: "Mari joined our office in October of 2020. Her kindness is evident the moment you meet her. She is very friendly and goes above and beyond to make sure each patient has a wonderful experience. Mari is an expert with insurance and coordinating appointments with the busy lives of our patients. When she is not in the office, you can find her spending time with her close-knit family, especially her two adorable daughters."
    },
    {
      name: "Maria",
      title: "Patient Care Coordinator",
      image: mariaImage,
      description: "Maria has been in the dental field since November 2010. Her rigorous training and experience has guided her to strive in the specialty of orthodontics. Her friendly, positive personality and compassionate attitude is the perfect addition to our team. In addition to traveling, listening to music, and anything Disney, Maria loves spending time with her family and friends."
    },
    {
      name: "Meghan, RDA",
      title: "Assistant",
      image: meghanImage,
      description: "Meghan joined our office in August of 2008. Her enthusiasm is infectious, and you can see how much fun she has at work. She is very outgoing and is absolutely the heart of this office. When she is not making patients laugh, she enjoys spending time with her husband and daughter, chauffeuring her to her various activities, like soccer, softball, dance, girl scouts, etc. You all know how that goes!"
    },
    {
      name: "Brandi, DA",
      title: "Assistant",
      image: brandiImage,
      description: "Brandi was a former patient who joined our team in September of 2014. She is one of the hardest workers you will ever meet; her loyalty is unsurpassed, and we can count on her for anything. Brandi makes every moment memorable and is excellent with our patients. When she is not at the office, you can find her spending time with her husband, enjoying country music concerts, 49er games, and traveling."
    },
    {
      name: "Gigi, DA",
      title: "Assistant",
      image: gigiImage,
      description: "Gigi joined the team in November of 2022. She is one of the sweetest people you will ever meet. Gigi is an extremely hard worker, and when she is not taking excellent care of our patients, she enjoys reading, hiking, playing piano, and spending time with her family. She graduated from San Francisco State in 2021 with a degree in Psychology and Holistic Health."
    }
  ];

  return (
    <section id="staff" className="staff-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Meet Our Exceptional Team</h2>
          <p className="section-subtitle">
            At San Mateo Orthodontics our friendly, capable staff is extremely dedicated in the delivery of orthodontic care to our patients. We are here to help you, the patient and parents, have an enjoyable experience with your orthodontic treatment.
          </p>
        </div>

        <div className="staff-intro">
          <div className="intro-content">
            <div className="intro-text">
              <h3 className="intro-title">Our Commitment to Excellence</h3>
              <p>
                We strive to be considerate of your time through efficient scheduling and the use of the latest technology in orthodontic appliances and materials. Our team combines years of experience with genuine care for every patient.
              </p>
              <div className="team-highlights">
                <div className="highlight-item">
                  <span className="highlight-number">18+</span>
                  <span className="highlight-text">Years Combined Experience</span>
                </div>
                <div className="highlight-item">
                  <span className="highlight-number">100%</span>
                  <span className="highlight-text">Licensed Professionals</span>
                </div>
              </div>
            </div>
            <div className="intro-image">
              <img src={teamImage} alt="San Mateo Orthodontics Team" className="team-photo" />
            </div>
          </div>
        </div>

        <div className="staff-grid">
          {staffMembers.map((member, index) => (
            <div key={index} className={`staff-member ${index === 0 ? 'featured' : ''}`}>
              <div className="staff-image">
                <img src={member.image} alt={member.name} />
              </div>
              <div className="staff-info">
                <h3 className="staff-name">{member.name}</h3>
                <h4 className="staff-title">{member.title}</h4>
                <div className="staff-description">
                  {member.description.split('\n\n').map((paragraph, pIndex) => (
                    <p key={pIndex}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Staff; 